<template>
	<div class="display-flex flex-row flex-align-center mt-2 mb-3 flex-justify-space-between">
		<div class="display-flex flex-row">
			<AnemicButton
				v-for="(tab, i) in selectItems"
				:key="tab.value + '_' + i"
				class="tab-button flex-centerize"
				@click="changeTab(tab.value)"
				:class="{ selected: selectedTab === tab.value }"
			>
				{{ tab.option }}
			</AnemicButton>
		</div>
	</div>
</template>
<script>
import { setIsSideBarDrawerOpen, setIsShowKnob } from '@/store/modules/sideBarDrawer/actions';
import { mapActionsShorthand } from '@/store/utils/mappers';
export default {
	name: 'SelectTabsCustomInput',
	props: { selectItems: { type: Array }, value: { type: String } },
	beforeDestroy() {
		this.setIsShowKnob(false);
	},
	mounted() {
		// If this component is expanded to be used anywhere other than transactional emails
		// there should be logic that checks if `is transactional email`
		// before setting isShowKnob, isSideBarDrawerOpen
		this.setIsShowKnob(true);
		this.setIsSideBarDrawerOpen(true);
	},
	data() {
		return { localTab: this.value };
	},
	computed: {
		selectedTab() {
			return this.localTab || this.value;
		},
	},
	methods: {
		...mapActionsShorthand({ setIsShowKnob, setIsSideBarDrawerOpen }),
		changeTab(tab) {
			this.localTab = tab;
			this.$emit('change-tab', tab);
		},
	},
};
</script>
<style lang="scss" scoped>
.tab-button {
	border-radius: 6px;
	height: 26px !important;
	font-size: 12px !important;
	padding: 0px 8px !important;
	border: 1px solid #e7eaf3;
	background: #f9fafc !important;
	&.selected {
		margin-left: -3px;
		color: var(--bold-border-color);
		background: var(--bg-color) !important;
		box-shadow: 0px 3px 6px var(--shadow-color) !important;
	}
}
</style>
